import { ComponentType } from 'react';
import { useNavigate } from 'react-router-dom';
import { BiSearch } from 'react-icons/bi';
import credit_card from '../../assets/icons/credit_card.png';
import faprint from '../../assets/icons/image 356.png';
import billing from '../../assets/icons/Group 1000007643.png';
import Order_Types from '../../assets/icons/Group.png';
import Staff_Management from '../../assets/icons/supervisor_account.png';
import Preferences from '../../assets/icons/Layer 2.png';
import vip from '../../assets/icons/vip.png';

import { FaWhatsapp, FaCreditCard } from 'react-icons/fa';

export interface SettingsCardType {
  id: string;
  label: string;
  path: string;
  icon: ComponentType<{ size?: number; className?: string }> | string;
}

export const SETTINGS_CARDS: SettingsCardType[] = [
  {
    id: 'whatsapp',
    label: 'Join Whatsapp Customer Group',
    path: '',
    icon: vip,
  },
  {
    id: 'billing',
    label: 'Billing',
    path: '',
    icon: billing,
  },

  {
    id: 'subscription',
    label: 'Subscription Plan',
    path: '',
    icon: FaCreditCard,
  },
  {
    id: 'printer',
    label: 'Buy Thermal Printer',
    path: '',
    icon: faprint,
  },
  {
    id: 'order-types',
    label: 'Order Types',
    path: '/settings/order-types',
    icon: Order_Types,
  },
  {
    id: 'items',
    label: 'Items and categories',
    path: '/settings/items-and-categories',
    icon: credit_card,
  },
  {
    id: 'staff',
    label: 'Staff Management',
    path: '',
    icon: Staff_Management,
  },
  {
    id: 'preferences',
    label: 'Preferences (Regional)',
    path: '',
    icon: Preferences,
  },
  {
    id: 'whatsapp-credits',
    label: 'WhatsApp Credits',
    path: '',
    icon: FaWhatsapp,
  },
];

const Settings = () => {
  const navigate = useNavigate();

  const handleCardClick = (path: string) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <div className="w-full h-full bg-[#F8F8FD] p-6">
      {/* Search Bar */}
      <div className="mb-6">
        <div className="relative max-w-md">
          <BiSearch
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            size={20}
          />
          <input
            type="text"
            placeholder="Search settings"
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Settings Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SETTINGS_CARDS.map((card: SettingsCardType) => {
          const isImageIcon = typeof card.icon === 'string';
          const IconComponent = isImageIcon ? null : card.icon;

          return (
            <div
              key={card.id}
              onClick={() => handleCardClick(card.path)}
              className="bg-white border border-gray-200 rounded-lg p-6 cursor-pointer hover:shadow-lg transition-shadow duration-200 flex flex-col items-center justify-center min-h-[150px]"
            >
              <div className="mb-4 flex items-center justify-center">
                {isImageIcon ? (
                  <img
                    src={card.icon as string}
                    alt={card.label}
                    className="w-12 h-12 object-contain"
                  />
                ) : (
                  IconComponent && <IconComponent size={48} className="text-gray-700" />
                )}
              </div>
              <p className="text-center text-[.85rem] text-[#000000] font-semibold">{card.label}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Settings;
